var ui_templates = require("ui-templates");
var lib_core           = require("lib-core");

var ImportDialogView = function(root,stateMachine,editorView) {

    this.root = root;
    this.stateMachine = stateMachine;
    this.editorView = editorView;
    this.importModal = undefined;
    this.initialize();
};

ImportDialogView.prototype.initialize = function () {

	var self = this;
	$('body').on('keydown', function (e) {
		if(e.ctrlKey && e.keyCode === 73) {
			self.show();
		}
	});
};

ImportDialogView.prototype.show = function(){
	if(!this.importModal) {
		this.importModal = this.editorView.getTemplate().addImportDialog();
		$(this.importModal.$el).on('Cioui:Modal:close:clicked', this.hide.bind(this));
		$(this.importModal.$el).on('Cioui:ImportModal:file:changed', this.fileSelected.bind(this));
	}
	else {
		this.importModal.show();
	}
};

ImportDialogView.prototype.hide = function () {
	if(this.importModal) {
		this.importModal.remove();
		delete this.importModal;
	}
};

ImportDialogView.prototype.fileSelected = function (e,files) {
	//HACK
	//jquery converts filelist to file if only 1 file is selected. We need to pass an array for consistency with other filelist operations

	if (typeof files !== Array) files = [files];
	var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.GUI_IMPORT_FILE)
            .data( 'files', files );
    var result = this.stateMachine.handle(cEvent);
    this.hide();
    return result;
};


module.exports = ImportDialogView;
